import {Component,lazy,ReactNode,Suspense} from 'react';

type WalkthroughLocation=Pick<Location,'hostname'|'pathname'|'search'>;
type RouteProps={location:WalkthroughLocation;fallback:ReactNode};

// Cache the module identity, never a route result, account or query credential.
const LocalRoute=lazy(()=>import('./LocalWalkthrough').then(module=>({
  default:({location,fallback}:RouteProps)=>module.resolveLocalWalkthrough(location)??fallback,
})));

class LocalLoadFailure extends Component<{children:ReactNode},{failed:boolean}> {
  state={failed:false};
  static getDerivedStateFromError(){return {failed:true};}
  render(){return this.state.failed
    ? <main className="shell"><p role="alert">The local walkthrough could not be loaded. No workspace was opened.</p></main>
    : this.props.children;}
}

/** The loader cannot run for production hosts or ordinary authentication/product routes. */
export function deferLocalWalkthrough(location:WalkthroughLocation,fallback:ReactNode):ReactNode {
  if(!['localhost','127.0.0.1','::1','[::1]'].includes(location.hostname)
    ||!location.pathname.replace(/^\/web(?=\/)/,'').startsWith('/walkthrough/'))return fallback;
  const snapshot={hostname:location.hostname,pathname:location.pathname,search:location.search};
  return <LocalLoadFailure><Suspense fallback={<main className="shell"><p role="status">Loading local walkthrough…</p></main>}>
    <LocalRoute location={snapshot} fallback={fallback}/>
  </Suspense></LocalLoadFailure>;
}
